<template>
  <div
    class="form-container"
  >
    <h2
      data-test="my-account-page-heading"
      class="page-title-heading"
    >
      {{ $localize('MyAccount') }}
    </h2>
    <p
      data-test="my-account-page-info"
      class="lead"
    >
      {{ $localize(AccountSpecificLabelsProvider.getAccountLabelKey('MyAccountLeadText')) }}
    </p>
    <div class="row">
      <div class="col-md-3">
        <VerticalTabMenu
          v-model="selectedTab"
          :items="[
            { text: $localize('UserDetails'), name: myAccountTabs.userDetailsTab },
            { text: $localize('ChangePassword'), name: myAccountTabs.changePasswordTab },
            { text: $localize(AccountSpecificLabelsProvider.getAccountLabelKey('AccountDetails')),
              name: myAccountTabs.accountDetailsTab },
          ]"
          :aria-label="$localize('MyAccount')"
        />
      </div>
      <div class="col-md-8 offset-md-1">
        <component
          :is="tabManager.resolveComponent(selectedTab)"
          :validation-rules="tabManager.resolveValidationRules(selectedTab)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import AccountSpecificLabelsProvider from '@/Utils/accountSpecificLabelsProvider';
  import VerticalTabMenu from '@/VueComponents/VerticalTabMenu/VerticalTabMenu.vue';
  import UserDetailsTab from '@/VueComponents/AccountDetails/UserDetailsTab.vue';
  import AccountDetailsTab from '@/VueComponents/AccountDetails/AccountDetailsTab.vue';
  import ChangePasswordTab from '@/VueComponents/AccountDetails/ChangePasswordTab.vue';
  import { ref } from 'vue';
  import { MyAccountPageTabManager } from '@/VueComponents/PageComponents/MyAccount/myAccountPageTabManager';
  import usePageLoading from '@/VueCore/utils/usePageLoading';
  import validationRulesService from '@/Services/validationRulesService';

  const myAccountTabs = {
    userDetailsTab: 'UserDetailsTab',
    changePasswordTab: 'ChangePasswordTab',
    accountDetailsTab: 'AccountDetailsTab'
  };

  const userDetailsValidation = ref();
  const accountDetailsValidation = ref();

  usePageLoading(async params => {
    userDetailsValidation.value = await validationRulesService.getValidationRules('user');
    accountDetailsValidation.value = await validationRulesService.getValidationRules('account');
  }, error => console.error('Failed to fetch validation rules:', error));

  const selectedTab = ref(myAccountTabs.userDetailsTab);

  // Expose selectedTab for testing purposes
  defineExpose({
    selectedTab
  });

  const tabManager = new MyAccountPageTabManager([
    { tabName: myAccountTabs.userDetailsTab, component: UserDetailsTab, validationRules: userDetailsValidation },
    { tabName: myAccountTabs.changePasswordTab, component: ChangePasswordTab },
    { tabName: myAccountTabs.accountDetailsTab, component: AccountDetailsTab, validationRules: accountDetailsValidation }
  ]);
</script>
